import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, useNavigate, useLocation } from 'react-router'
import { configureStore } from '@reduxjs/toolkit'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import * as Sentry from '@sentry/react'
// import { Spin } from 'antd'

import conf from 'conf'
import history from 'history'

import reducers from './redux/reducers'
import sagas from './redux/sagas'
import Localization from './localization'
import Router from './router'

import * as serviceWorker from './serviceWorker'

import { initSentry } from './sentry'
// import { SERVICE_LOGO_IMAGE } from './service'
import './global.scss'

// middleware
const sagaMiddleware = createSagaMiddleware()
const middlewares = [sagaMiddleware]

console.info(`${conf.packageInfo.name} ${conf.packageInfo.version}`)
console.info(`Git branch : ${conf.gitInfo.branch}`)
console.info(`Git date : ${conf.gitInfo.commit.date}`)
console.info(`Git date : ${process.env.REACT_APP_TARGET}`)

const store = configureStore({
  reducer: reducers(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  devTools: process.env.REACT_APP_TARGET !== 'production',
})

sagaMiddleware.run(sagas)

const NavigateSetter = () => {
  history.navigate = useNavigate()
  history.location = useLocation()

  const { location, notifyLocationChange } = history

  useEffect(() => {
    notifyLocationChange(location)
  }, [location, notifyLocationChange])

  return null
}

const root = ReactDOM.createRoot(document.getElementById('root'))

const browserRouterAttrs = {}

initSentry()

// const LoadingFallback = () => (
//   <div
//     style={{
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       width: '100%',
//       height: '100%',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       backgroundColor: '#ffffff',
//       zIndex: 9999,
//       gap: '32px',
//     }}
//   >
//     <img
//       src={SERVICE_LOGO_IMAGE}
//       alt="Logo"
//       style={{
//         width: '200px',
//         height: 'auto',
//         maxWidth: '80%',
//       }}
//     />
//     <Spin size="large" />
//   </div>
// )

root.render(
  <Sentry.ErrorBoundary>
    <BrowserRouter {...browserRouterAttrs}>
      <NavigateSetter />
      <Provider store={store}>
        <Localization>
          {/* <Suspense fallback={<LoadingFallback />}> */}
          <Router history={history} />
          {/* </Suspense> */}
        </Localization>
      </Provider>
    </BrowserRouter>
  </Sentry.ErrorBoundary>,
)

serviceWorker.unregister()
export { store, history }
